import React, { useEffect, useState } from "react";
import "./OrdersList.scss";
import TableComponent from "../../components/TableComponent/TableComponent";
import { Button, Descriptions, Modal, Spin } from "antd";
import { GET_ORDERS_LIST, GET_ORDER_DETAILS } from "../../utils/apiPath";
import { getApi, postApi } from "../../utils/apiServices";
import { EyeOutlined } from "@ant-design/icons";
import { IMAGE_BASE_PATH } from "../../utils/constant";

const OrdersList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const formatDate = (d) => {
    const date = new Date(d);
    const formatted = date.toLocaleString();
    return formatted;
  };

  const items1 = [
    {
      key: "1",
      label: "Customer name",
      children: orderDetails?.customerDetails?.customerName || "empty",
    },
    {
      key: "2",
      label: "Email",
      children: orderDetails?.customerDetails?.customerEmail || "empty",
    },
    {
      key: "3",
      label: "Phone number",
      children: orderDetails?.customerDetails?.customerPhoneNumber || "empty",
    },
  ];

  const items2 = [
    {
      key: "5",
      label: "Name",
      children: orderDetails?.shippingAddress?.name || "empty",
    },
    {
      key: "6",
      label: "Phone number",
      children: orderDetails?.shippingAddress?.mobileNumber || "empty",
    },
    {
      key: "7",
      label: "Order date",
      children: formatDate(orderDetails?.orderDate) || "empty",
    },
    {
      key: "8",
      label: "Total amout",
      children: orderDetails?.totalAmount || "empty",
    },
    {
      key: "1",
      label: "Country",
      children: orderDetails?.shippingAddress?.countryName || "empty",
    },
    {
      key: "2",
      label: "State",
      children: orderDetails?.shippingAddress?.stateName || "empty",
    },
    {
      key: "3",
      label: "City",
      children: orderDetails?.shippingAddress?.cityName || "empty",
    },
    {
      key: "4",
      label: "Address",
      children:
        `${orderDetails?.shippingAddress?.address1} ${orderDetails?.shippingAddress?.address2}` ||
        "empty",
    },
  ];

  const showModal = (data) => {
    setOrderDetails(null);
    if (!isModalOpen) {
      fetchOrderDetails(data?.orderId);
    }
    setIsModalOpen(!isModalOpen);
  };

  const fetchOrderDetails = async (id) => {
    setIsLoading(true);
    try {
      const { statusCode, data, message } = await getApi(
        `${GET_ORDER_DETAILS}?orderId=${id}`
      );

      if (statusCode === 200) {
        setOrderDetails(data);
      } else {
        console.error("Failed to fetch orders list:", message);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const payload = {
        pageIndex: pagination.current - 1,
        pageSize: pagination.pageSize,
        searchString: "",
      };
      const { statusCode, data, message } = await postApi(
        GET_ORDERS_LIST,
        payload
      );

      if (statusCode === 200) {
        setData(data);
        setPagination((prev) => ({ ...prev, total: data?.totalRecords }));
      } else {
        console.error("Failed to fetch orders list:", message);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
    setLoading(false);
  };

  const columns = [
    {
      title: "Sl No",
      dataIndex: "name",
      sorter: false,
      render: (_, __, index) =>
        (pagination?.current - 1) * pagination?.pageSize + (index + 1),
    },
    {
      title: "Name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Email",
      dataIndex: "customerEmail",
      key: "customerEmail",
    },
    {
      title: "Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (text) => `${text.toFixed(2)}`,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <Button onClick={() => showModal(record)}>
          <EyeOutlined /> View
        </Button>
      ),
    },
  ];

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  return (
    <div className="orders">
      <div className="orders_container">
        <div className="orders_header">
          <div className="orders_header_left">Orders</div>
        </div>
        <TableComponent
          columns={columns}
          data={data}
          pagination={pagination}
          loading={loading}
          onTableChange={handleTableChange}
        />
      </div>
      <Modal
        title="Order details"
        width={1000}
        open={isModalOpen}
        onCancel={showModal}
        footer={false}
        centered={true}
        maskClosable={false}
      >
        <Spin spinning={isLoading}>
          <div className="orders_details">
            {orderDetails?.orderItems?.map((order, index) => {
              const items = [
                {
                  key: "1",
                  label: "Product Name",
                  children: order.productName,
                },
                {
                  key: "3",
                  label: "Selling Price",
                  children: `₹${order.sellingPrice}`,
                },
                {
                  key: "4",
                  label: "Quantity",
                  children: order.quantity,
                },
                {
                  key: "5",
                  label: "Color",
                  children: order.productColor,
                },
                {
                  key: "6",
                  label: "Size",
                  children: order.productSize,
                },
                {
                  key: "7",
                  label: "Payment Status",
                  children: order.paymentStatus,
                },
                {
                  key: "8",
                  label: "Order Status",
                  children: order.orderStatus,
                },
                {
                  key: "9",
                  label: "Images",
                  children: (
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      {order?.Images.map((img, idx) => (
                        <img
                          key={idx}
                          src={`${IMAGE_BASE_PATH}${img.media}`}
                          alt={img.altText || `Image ${idx + 1}`}
                          style={{ width: 60, height: 60, borderRadius: 4 }}
                        />
                      ))}
                    </div>
                  ),
                },
              ];

              return (
                <div key={index}>
                  <Descriptions
                    title={`Product Details`}
                    layout="vertical"
                    items={items}
                    bordered
                  />
                </div>
              );
            })}
            <Descriptions
              title={`Customer Details`}
              layout="vertical"
              items={items1}
              bordered
            />
            <Descriptions
              title={`Shipping Address`}
              layout="vertical"
              items={items2}
              bordered
            />
          </div>
        </Spin>
      </Modal>
    </div>
  );
};

export default OrdersList;
